import { Controller } from "stimulus"
export default class extends Controller {
  static get targets() {
    return ['shorten'];
  }
  initialize(){
    let max = parseInt(this.data.get('max-length'));
    this.shortenTargets.forEach(function(text,i ){
      if (text.innerText.length > max) {
        var origText = text.innerText; 
        var firstSpaceIndex = origText.indexOf(" ", max); 
        if (firstSpaceIndex > 0) {
        text.innerText = origText.substring(0, firstSpaceIndex) + " ...";
        var hiddenText = origText.substring(firstSpaceIndex, origText.length - 1); 
        var elem = document.createElement('p'); 
        elem.style.height = '0px'; 
        elem.style.visibility = 'hidden'; 
        elem.innerText = hiddenText; 
        text.append(elem); 
        }


      }
      

    });

  }

}
